module.exports = __webpack_public_path__ + "img/page11.bb5c1c00.png";